import { appData } from '@/mocks/cinema';

export default function SectionApp() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="section-container px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-50 rounded-2xl border border-background-200/30 p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-4">
              {appData.title}
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              {appData.description}
            </p>
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-6">
              {appData.features.map((f) => (
                <span
                  key={f}
                  className="px-3 py-1 rounded-full bg-secondary-500/10 text-secondary-400 text-xs font-medium whitespace-nowrap border border-secondary-500/15"
                >
                  {f}
                </span>
              ))}
            </div>
            <a
              href="#cards"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line" />
              下载 App
            </a>
          </div>
          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="rounded-2xl overflow-hidden border-4 border-background-200/40">
              <img
                src={appData.image}
                alt="夜猫追剧App"
                className="w-full h-auto object-cover object-top"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}